// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const moment = require('moment');

// @commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const ModifyChoreStep1 = require('components/cards/cardOpenYoung/cardOpenYoungModifyChoreSteps/modifyChoreStep1/modifyChoreStep1');
const ModifyChoreStep2 = require('components/cards/cardOpenYoung/cardOpenYoungModifyChoreSteps/modifyChoreStep2/modifyChoreStep2');
const ModifyChoreFinalStep = require('components/cards/cardOpenYoung/cardOpenYoungModifyChoreSteps/modifyChoreFinalStep/modifyChoreFinalStep');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const CardDetailsSidebar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');

// @constants
const { GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');

// @actions
const openYoungCardModifyChoreAction = require('actions/openYoungCardModifyChore');
const openYoungCardChores = require('actions/openYoungCardChores');

class OpenYoungCardModifyChoresView extends React.Component {
    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.goToMovementsPage = this.goToMovementsPage.bind(this);
    }

    componentWillMount() {
        const { match: { params: { cardId, choreAssignmentId } }, openYoungCardChores, history} = this.props;
        this.props.reset();
        this.props.getChoresList();
        this.props.getChoreDetail(choreAssignmentId);

        const immChoreDetails = openYoungCardChores.get('choreDetail');
        const amount = immChoreDetails.get('reward');
        const selectedEndDate = moment(immChoreDetails.get('endDate'));
        const selectedChoreType = formatText(`openYoungCardChores-task${immChoreDetails.getIn(['chore','choreId'])}`);
        const selectedRepeatTask = immChoreDetails.get('repeatTask')
        const choreAssignmentComment = immChoreDetails.getIn(['comments','choreAssignmentComment'])

        this.props.handleAmountChange(amount);
        this.props.validityDateChanged(selectedEndDate);
        this.props.setChoreType(selectedChoreType);
        this.props.setRepetitionType(selectedRepeatTask);
        this.props.conceptChanged(choreAssignmentComment);

        if (openYoungCardChores.get('choreDetail').isEmpty()) {
            //if is editing and the page reloads, redirect to chore
            history.push(`/myprofile/cards/${cardId}/chores`);
        }

    }

    componentDidMount() {
        const { immCards, match: { params: { cardId } }, setTotalAvailableBalance } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        setTotalAvailableBalance(immCard.getIn(['availableBalance', 'amount']));
    }
    goToMovementsPage() {
        const { match: { params: { cardId } }, history } = this.props;

        history.push(`/myprofile/cards/${cardId}/movements`);
    }
    handleCancel() {
        const { cardId } = this.props.match.params;
        this.props.history.push(`/myprofile/cards/${cardId}/chores`);
    }

    handleFinish() {
        const { match: { params: { cardId, choreAssignmentId } }, immCards,immOpenYoungCardModifyChore } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const step =  immOpenYoungCardModifyChore.getIn(['steps', 0]);
        this.props.handleFinish(immCard, step, choreAssignmentId);
    }

    buildWizard(immCard) {
        const {
            conceptChanged,
            getChoreDetail,
            handleAmountChange,
            immOpenYoungCardModifyChore,
            openYoungCardChores,
            match: { params: { choreAssignmentId } },
            setChoreType,
            setRepetitionOptionsList,
             setRepetitionType,
            setVisibleStep,
            setWillCancel,
            validateStep,
            validityDateChanged
        } = this.props;
        const immSteps = immOpenYoungCardModifyChore.get('steps');
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };
        const immStep = immOpenYoungCardModifyChore.get('steps').get(0);
        const immChoreDetails = this.props.openYoungCardChores.get('choreDetail');

        const isSameAmount = immChoreDetails.get('reward') === immStep.get('amount');
        const isSameSelectedEndDate = moment(immChoreDetails.get('endDate')).isSame(moment(immStep.get('selectedEndDate')).format());
        const isSameConcept = immStep.get('concept') === immChoreDetails.getIn(['comments','choreAssignmentComment']);

        let nextButtonDisabledFlag = isSameAmount && isSameSelectedEndDate && isSameConcept ;

        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                showPreLeaveModal={true}
                stepsAmount={immSteps.size}
                visibleStep={immOpenYoungCardModifyChore.get('visibleStep')}>
                <WizardStep position="first" cancelButton={true} nextButtonDisabled={nextButtonDisabledFlag} >
                    <ModifyChoreStep1
                        conceptChanged={conceptChanged}
                        handleAmountChange={handleAmountChange}
                        getChoreDetail={getChoreDetail}
                        immCard={immCard}
                        immStep={immOpenYoungCardModifyChore.getIn(['steps', 0])}
                        immOpenYoungCardModifyChore={immOpenYoungCardModifyChore}
                        immChoreDetails={openYoungCardChores.get('choreDetail')}
                        setChoreType={setChoreType}
                        validityDateChanged={validityDateChanged}
                        setRepetitionType={setRepetitionType}
                        setRepetitionOptionsList={setRepetitionOptionsList}
                        choreAssignmentId={choreAssignmentId}
                    />
                </WizardStep>
                <WizardStep
                    addLoadingBehaviour={false}
                    cancelButton={true}
                    immFinalButton="openYoungModifyChores-confirm"
                    position="last">
                    <ModifyChoreStep2
                        immCard={immCard}
                        immChoreDetails={openYoungCardChores.get('choreDetail')}
                        immOpenYoungCardModifyChore={immOpenYoungCardModifyChore.getIn(['steps', 0])}
                    />
                </WizardStep>
            </Wizard>
        )
    }

    buildSuccessful() {
        const {
            immCards,
            immOpenYoungCardModifyChore,
            openYoungCardChores,
            match: { params: { cardId } }
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-10">
                <ModifyChoreFinalStep
                    errorState={immOpenYoungCardModifyChore.get('submitError')}
                    immOpenYoungCardModifyChore={immOpenYoungCardModifyChore.getIn(['steps', 0])}
                    immCard={immCard}
                    immChoreDetails={openYoungCardChores.get('choreDetail')}
                />
            </div>
        )
    }

    render() {
        const { match: { params: { cardId } }, immCards, immOpenYoungCardModifyChore } = this.props;
        const immCard = immCards.getIn(['byId', cardId]) ;
        let content;
        let bodyContent;

        if (immCards.get('isFetching')) {
            content = <LoadingSection />;
        } else if (immCard) {
            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = immCard.getIn(['alias', 'current']);
            const initialUrl = '/myprofile/cards'
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: initialUrl
                },
                {
                    text: immCard.get('alias').get('current'),
                    url: `${initialUrl}/${cardId}/movements`
                },
                {
                    text: formatText('breadcrumb-openYoungChores'),
                    url: `${initialUrl}/${cardId}/chores`
                },
                {
                    text: formatText('breadcrumb-openYoungModifyChores')
                }
            ];
            const tutorial = (
                <TutorialLauncher
                    type={GRAPHIC_TUTOR_TYPE_4}
                    title={formatText('tutorials-openYoungModifyChoreTitle')}
                />
            );
            if (immOpenYoungCardModifyChore.get('submitSuccessful') || immOpenYoungCardModifyChore.get('submitError')) {
                bodyContent = this.buildSuccessful(immCard);
            } else {
                const wizard = this.buildWizard(immCard);
                bodyContent = (
                    <div className="row">
                        <div className="col-md-12 hidden-lg grid-view--fix-cell-separation-bottom">
                            <CardDetailsSidebar immCard={immCard} />
                        </div>
                        <div className="col-md-12 col-lg-8">
                            {wizard}
                        </div>
                        <div className="lg-down col-lg-4">
                            <CardDetailsSidebar immCard={immCard} />
                        </div>
                    </div>
                );
            }
            content = (
                <div className="open-young-management">
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    tutorial={tutorial}
                                    finalTitle={getFinalTitle('openYoungModifyChores-title')}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                />
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                {bodyContent}
                            </div>
                        </div>
                    </div>
                </div>
            );

        }

        return content;
    }
}
OpenYoungCardModifyChoresView.propTypes = {
    conceptChanged: PropTypes.func.isRequired,
    getChoresList: PropTypes.func.isRequired,
    getChoreDetail: PropTypes.func.isRequired,
    handleAmountChange: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immOpenYoungCardModifyChore: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    openYoungCardChores: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    setChoreType: PropTypes.func.isRequired,
    setRepetitionOptionsList: PropTypes.func.isRequired,
    setRepetitionType: PropTypes.func.isRequired,
    setTotalAvailableBalance: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    validityDateChanged: PropTypes.func.isRequired
};
module.exports.constructor = OpenYoungCardModifyChoresView;
module.exports.OpenYoungCardModifyChoresView = connect(
    state => ({
        immCards: state.cards,
        immOpenYoungCardModifyChore: state.openYoungCardModifyChore,
        openYoungCardChores: state.openYoungCardChores
    }), {
        conceptChanged: openYoungCardModifyChoreAction.conceptChanged,
        getChoreDetail: openYoungCardChores.getChoreDetail,
        getChoresList: openYoungCardModifyChoreAction.getChoresList,
        handleAmountChange: openYoungCardModifyChoreAction.setAmount,
        handleFinish: openYoungCardModifyChoreAction.postChoreConfirm,
        reset: openYoungCardModifyChoreAction.reset,
        setChoreType: openYoungCardModifyChoreAction.setChoreType,
        setRepetitionOptionsList: openYoungCardModifyChoreAction.setRepetitionOptionsList,
        setRepetitionType: openYoungCardModifyChoreAction.setRepetitionType,
        setTotalAvailableBalance: openYoungCardModifyChoreAction.setTotalAvailableBalance,
        setVisibleStep: openYoungCardModifyChoreAction.setVisibleStep,
        setWillCancel: openYoungCardModifyChoreAction.setWillCancel,
        validateStep: openYoungCardModifyChoreAction.validateStep,
        validityDateChanged: openYoungCardModifyChoreAction.validityDateChanged
    })(withRouter(OpenYoungCardModifyChoresView));

